// Cinco Elementos — extraído das páginas 7-8 e 9-10 do PDF. Fiel ao material.

export const ELEMENTS = [
  {
    id: "madeira",
    name: "Madeira",
    palavras: ["Crescer", "Expandir", "Planejar"],
    descricao: "Representa o nascimento, o crescimento e a flexibilidade.",
    orgaos: ["Fígado", "Vesícula Biliar"],
    orgaoIds: ["figado", "vesicula-biliar"],
    emocao: "Raiva",
    sabor: "Azedo",
    qualidades: "Criatividade, iniciativa, coragem, visão e determinação.",
    desequilibrio: "tensão muscular, dores de cabeça, irritabilidade, olhos vermelhos.",
    sourcePages: [7, 8],
  },
  {
    id: "fogo",
    name: "Fogo",
    palavras: ["Alegria", "Comunicar", "Transformar"],
    descricao: "Simboliza o calor, o entusiasmo e a expansão da consciência.",
    orgaos: ["Coração", "Intestino Delgado", "Pericárdio", "Triplo Aquecedor"],
    orgaoIds: ["coracao", "intestino-delgado", "pericardio", "triplo-aquecedor"],
    emocao: "Alegria",
    sabor: "Amargo",
    qualidades: "Alegria, amor, entusiasmo, comunicação, clareza mental.",
    desequilibrio: "insônia, ansiedade, palpitações, boca seca, agitação.",
    sourcePages: [7, 8],
  },
  {
    id: "terra",
    name: "Terra",
    palavras: ["Nutrir", "Transformar", "Estabilizar"],
    descricao: "É o centro que sustenta. Representa equilíbrio, nutrição e capacidade de transformar.",
    orgaos: ["Baço-Pâncreas", "Estômago"],
    orgaoIds: ["baco-pancreas", "estomago"],
    emocao: "Preocupação",
    sabor: "Doce Natural",
    qualidades: "Estabilidade, empatia, generosidade, confiança, cuidado.",
    desequilibrio: "cansaço, digestão lenta, inchaço, excesso de preocupação.",
    sourcePages: [7, 8],
  },
  {
    id: "metal",
    name: "Metal",
    palavras: ["Organizar", "Limpar", "Desapegar"],
    descricao: "Simboliza a estrutura, a ordem e o processo de soltar o que não serve mais.",
    orgaos: ["Pulmão", "Intestino Grosso"],
    orgaoIds: ["pulmao", "intestino-grosso"],
    emocao: "Tristeza",
    sabor: "Picante",
    qualidades: "Disciplina, justiça, clareza, desapego, integridade.",
    desequilibrio: "tristeza profunda, pele ressecada, tosse, constipação.",
    sourcePages: [7, 8],
  },
  {
    id: "agua",
    name: "Água",
    palavras: ["Guardar", "Descansar", "Renovar"],
    descricao: "Representa profundidade, sabedoria e potencial da vida.",
    orgaos: ["Rins", "Bexiga"],
    orgaoIds: ["rins", "bexiga"],
    emocao: "Medo",
    sabor: "Salgado",
    qualidades: "Sabedoria, calma, vontade, perseverança, força interior.",
    desequilibrio: "medo, lombar sensível, fadiga, retenção de líquidos.",
    sourcePages: [7, 8],
  },
];

// Ciclos dos Cinco Elementos (página 7)
export const CICLO_GERACAO = [
  { de: "madeira", para: "fogo", texto: "Madeira nutre o Fogo" },
  { de: "fogo", para: "terra", texto: "Fogo gera a Terra" },
  { de: "terra", para: "metal", texto: "Terra gera o Metal" },
  { de: "metal", para: "agua", texto: "Metal gera a Água" },
  { de: "agua", para: "madeira", texto: "Água nutre a Madeira" },
];

export const CICLO_CONTROLE = [
  { de: "madeira", para: "terra", texto: "Madeira controla a Terra" },
  { de: "terra", para: "agua", texto: "Terra controla a Água" },
  { de: "agua", para: "fogo", texto: "Água controla o Fogo" },
  { de: "fogo", para: "metal", texto: "Fogo controla o Metal" },
  { de: "metal", para: "madeira", texto: "Metal controla a Madeira" },
];

export const CICLOS_DESCRICAO = {
  geracao: "Ciclo de Geração (Sheng): um elemento nutre e dá origem ao próximo, em um movimento de criação e crescimento.",
  controle: "Ciclo de Controle (Ke): cada elemento regula o outro, mantendo o equilíbrio e evitando excessos.",
};

export const getElement = (id) => ELEMENTS.find((e) => e.id === id);
